<template>
    <div class="loading" v-if="isLoading||isAppLoading">
        <div class="h-100 row m-auto">
            <div class="m-auto" v-if="isLoading">
                Loading...
            </div>
            <div class="m-auto" v-if="!isLoading&&isAppLoading">
                Getting data...
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'loading',
    computed: {
      ...mapGetters({
        isLoading: 'loading/isLoading',
        isAppLoading: 'loading/isAppLoading'
      })
    },
  };
</script>

<style scoped>
    div.loading {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.5;
        height: 100%;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue